import React from 'react';

const UnderlineTabs = ({ tabs, activeValue, onChange }) => {
    return (
        <div className="flex gap-6 border-b border-gray-200 overflow-x-auto whitespace-nowrap scrollbar-hide">
            {tabs.map((tab, index) => {
                const value = tab.value;
                const isActive = activeValue === value;

                return (
                    <button
                        key={index}
                        onClick={() => onChange(tab)}
                        className={`
                            pb-3 text-sm font-semibold
                            transition-all duration-200 ease-in-out
                            focus:outline-none
                            ${
                                isActive
                                    ? 'text-blue-600 border-b-2 border-blue-600'
                                    : 'text-gray-500 border-b-2 border-transparent hover:text-gray-800'
                            }
                        `}
                    >
                        {tab?.label}
                    </button>
                );
            })}
        </div>
    );
};

export default UnderlineTabs;
